<div class="admin-layout">
  <!-- Toolbar -->
  <mat-toolbar color="primary" class="toolbar">
    <span class="toolbar-title">
      <mat-icon>admin_panel_settings</mat-icon>
      Panel Administrativo Workbi
    </span>

    <span class="spacer"></span>

    <!-- User Menu -->
    <button mat-icon-button [matMenuTriggerFor]="userMenu" class="user-menu-button">
      <mat-icon>account_circle</mat-icon>
    </button>
    <mat-menu #userMenu="matMenu">
      <div class="user-info" mat-menu-item disabled>
        <mat-icon>person</mat-icon>
        <span>{{ currentUser }}</span>
      </div>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Cerrar Sesión</span>
      </button>
    </mat-menu>
  </mat-toolbar>

  <!-- Content Area -->
  <div class="content-wrapper">
    <!-- Sidebar Navigation -->
    <nav class="sidebar" *ngIf="permissions.length > 0">
      <div class="nav-items">
        <a
          *ngFor="let permission of permissions"
          [routerLink]="['/admin' + permission.pagePath]"
          routerLinkActive="active"
          class="nav-item"
          [title]="permission.pageDescription"
        >
          <mat-icon>{{ permission.icon || 'dashboard' }}</mat-icon>
          <span>{{ permission.pageName }}</span>
        </a>
      </div>
    </nav>

    <!-- Main Content -->
    <main class="main-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
